export default "__VITE_ASSET__CHc$LKbP__"